<template>
  <PageNavigation />
  <div class="margin-section">
      <div>
          <InsertImage titlePage="RECRUITMENT" titlePageJP="採用情報"/>
      </div>
      <div class="half-block-content">
        <div id="registered_nurse">
          <h2 v-fade-in>看護師の求人情報</h2>
          <div class="center">
              <img alt="Circle objects" src="@/assets/images/circle_objects.png" class="display-circle-obj" width="180" height="21.77" />
          </div>
          <div class="recruitment-status" v-fade-in>
            <!-- <span class="recruiting-badge">募集中</span> -->
            <span class="not-recruiting-badge">募集停止中</span>
          </div>
          <p v-fade-in>現在、人員の募集は行っておりません。</p>
        </div>
      </div>
  </div>
  <PageFooter />
</template>

<script>
import PageNavigation from '@/components/PageNavigation.vue';
import PageFooter from '@/components/PageFooter.vue';
import InsertImage from '@/components/InsertImage.vue';

export default {
  name: 'NurseRecruitmentPage',
  components: {
    PageNavigation,
    PageFooter,
    InsertImage,
  },
  data() {
    return {
    };
  },
}
</script>

<style scoped>

.recruitment-status {
  text-align: center;
  margin: 1em 0;
}

.recruiting-badge {
  display: inline-block;
  background-color: #28a745;
  color: white;
  padding: 0.5em 1.5em;
  border-radius: 20px;
  font-weight: bold;
  font-size: 16px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}


.not-recruiting-badge {
  display: inline-block;
  background-color: #888888;
  color: white;
  padding: 0.5em 1.5em;
  border-radius: 20px;
  font-weight: bold;
  font-size: 16px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

@media (max-width: 768px) {
  .not-recruiting-badge {
    font-size: 14px;
    padding: 0.4em 1.2em;
  }
}

</style>